import Bridge from '@wifikey/wkb'
import Tracker from './Tracker'

window.wkb = Bridge
var Utils = {
    Bridge: Bridge,
    Tracker: Tracker
};
window.Utils = Utils;
//module.exports = Utils;


// WEBPACK FOOTER //
// ./src/lib/Utils/index.js